import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle, RefreshCw, Moon } from "lucide-react";
import { BRAND, errMsg } from "./constants";

export function SummaryPanel({ pid, authFetch, API }) {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => authFetch({ url: `${API}/homestay/properties/${pid}/summaries` }).then((r) => setItems(r.data.items)).catch(() => {}), [pid, authFetch, API]);
  useEffect(() => { load(); }, [load]);

  const generate = async () => {
    setBusy(true);
    try { await authFetch({ method: "post", url: `${API}/homestay/properties/${pid}/summary/generate` }); toast.success("Today's summary refreshed"); load(); }
    catch (e) { toast.error(errMsg(e, "Could not generate summary")); }
    finally { setBusy(false); }
  };

  const latest = items[0];
  return (
    <div data-testid="summary-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-sm font-bold inline-flex items-center gap-1.5" style={{ color: BRAND.green }}><Moon className="w-4 h-4" /> Daily summary · 11:30 AM</div>
        <button disabled={busy} data-testid="summary-generate-btn" onClick={generate} className="text-xs font-bold inline-flex items-center gap-1" style={{ color: BRAND.orange }}>
          <RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} /> Refresh today
        </button>
      </div>
      <p className="text-xs mt-0.5" style={{ color: BRAND.muted }}>Every day at 11:30 AM IST the owner and managers get this in their notifications. Tap to forward it on WhatsApp.</p>
      {!latest && <div className="mt-3 text-xs" style={{ color: BRAND.muted }} data-testid="summary-empty">No summary yet — tap Refresh today.</div>}
      {latest && (
        <>
          <pre data-testid="summary-text" className="mt-3 rounded-xl p-3 text-xs whitespace-pre-wrap font-sans" style={{ background: "#F0FDF4", color: "#14532D" }}>{latest.text}</pre>
          <a href={latest.wa_url} target="_blank" rel="noreferrer" data-testid="summary-wa-btn"
            className="mt-3 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold text-white shadow transition-transform hover:-translate-y-0.5" style={{ background: "#16A34A" }}>
            <MessageCircle className="w-4 h-4" /> Send on WhatsApp
          </a>
        </>
      )}
      {items.length > 1 && (
        <div className="mt-4 divide-y text-xs" data-testid="summary-history">
          {items.slice(1, 8).map((s) => (
            <div key={s.id} className="py-1.5 flex justify-between" style={{ color: BRAND.muted }}>
              <span>{s.date}</span>
              <span>{s.stats.occupancy_pct}% occ · ₹{s.stats.collected_inr.toLocaleString("en-IN")} · {s.stats.checkouts_tomorrow.length} out</span>
              <a href={s.wa_url} target="_blank" rel="noreferrer" className="font-bold" style={{ color: "#16A34A" }}>WhatsApp</a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
